export default __webpack_public_path__ + "static/media/text-chat-blue.1bd17ad2.svg";